import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import SkillsEvents from './SkillsEvents';

import SkillsDetailsSectionInfo from './details/sections/SkillsDetailsSectionInfo';
import SkillsDetailsSectionSecondaryInfo from './details/sections/SkillsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<SkillsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="skll_descriptionhtml"
				value={props.model.skll_descriptionhtml}
				sendChange={props.sendChange}
				isEdit={props.isEdit}
			/>
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<SkillsDetailsSectionSecondaryInfo {...props} />
		</>
	),
	events: SkillsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
